<template>
  <div
    class="avt-contain"
    :style="
      this.size
        ? {
            height: `${this.size}px`,
            width: `${this.size}px`,
            'border-radius': `${this.size * 0.12}px`
          }
        : {}
    "
    @mouseenter="showChallenge=true"
    @mouseleave="showChallenge=false"
  >
    <router-link :to="`/user/${username}`">
      <img
        :src="
          require(`../assets/${
            setAvatar ? `avatars/${setAvatar}.png` : 'unknown.png'
          }`)
        "
        :style="
          this.size
            ? {
                height: `${this.size}px`,
                width: `${this.size}px`,
                'border-radius': `${this.size * 0.12}px`
              }
            : {}
        "
        alt
      />
    </router-link>
    <div
      class="online-status"
      v-if="
        online ||
          (online === undefined &&
            !!onlineUsers.map(u => u.username).includes(username))
      "
      :style="
        this.size
          ? {
              width: `${this.size * 0.22}px`,
              height: `${this.size * 0.22}px`,
              bottom: `${-(this.size * 0.22 * 0.3)}px`,
              right: `${-(this.size * 0.22 * 0.3)}px`,
              'border-radius': `${this.size * 0.22 * 0.5}px`
            }
          : {}
      "
    />
    <div class="challenge-modal" v-if="challengeModal && showChallenge" :style="{bottom: this.size}">
      <p style="margin-bottom: 5px;">
        <router-link :to="`/user/${username}`">{{username}} </router-link><small v-if="rank">({{rank}})</small>
      </p>
      <button :disabled="credits < 5" @click="createPrivateDuel">CHALLENGE <div class="credit-display">5<img src="@/assets/credits.png"></div></button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    username: String,
    rank: [String, undefined],
    avatar: [String, undefined],
    online: [Boolean, undefined],
    size: [Number, undefined],
    credits: [Number, undefined],
    challengeModal: [Boolean, undefined]
  },
  data() {
    return { setAvatar: undefined, onlineUsers: [], showChallenge: false };
  },
  mounted() {
    this.init();
  },
  sockets: {
    connect() {
      this.init();
    },
    globalUsers(data) {
      if (this.online === undefined) {
        this.onlineUsers = data;
      }

      if (this.avatar === undefined) {
        let onlineUser = data.find(u => u.username === this.username);

        if (onlineUser) {
          this.setAvatar = onlineUser.avatar;
        } else {
          this.requestAvatar();
        }
      }
    }
  },
  methods: {
    init() {
      // we have a specified avatar
      if (this.avatar) {
        this.setAvatar = this.avatar;
      }
      // we need to figure out if user is online
      if (this.online === undefined) {
        this.$socket.emit("user.list");
      } else if (!this.avatar) {
        this.requestAvatar();
      }
    },
    // request the avatar from the server
    requestAvatar() {
      this.$socket.emit("avatar.get", this.username, avatar => {
        this.setAvatar = avatar;
      });
    },
    createPrivateDuel() {
      this.$socket.emit(
        "duel.private.new",
        this.username,
        (err, gameID) => {
          if (err) {
            this.$alert(err);
          } else {
            this.$router.push(`/duel/${gameID}`);
          }
        }
      );
    }
  }
};
</script>
<style scoped>
.avt-contain {
  width: 45px;
  height: 45px;
  background: #666;
  border-radius: 3px;
  position: relative;
}
img {
  width: 45px;
  height: 45px;
  border-radius: 3px;
}
.online-status {
  position: absolute;
  bottom: -3px;
  right: -3px;
  height: 10px;
  width: 10px;
  border-radius: 5px;
  background: #55dc0d;
}
.challenge-modal {
  display: block;
  padding: 8px;
  text-align: left;
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  color: #ccc;
  font-weight: normal;
  display: block;
  width: 180px;
  border-radius: 8px;
  z-index: 10;
}
.challenge-modal a:hover {
  color: white;
}
</style>
